import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ArrowAhead: React.FC<CardGradientProps> = ({
  className,
  width = "16",
  height = "16",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2431_13794"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          x="16"
          y="16"
          width="16"
          height="16"
          transform="rotate(180 16 16)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2431_13794)">
        <path
          d="M10.7841 7.33338L7.51745 4.06672C7.38411 3.93338 7.32022 3.77783 7.32578 3.60005C7.33133 3.42227 7.40078 3.26672 7.53411 3.13338C7.66745 3.01116 7.823 2.94727 8.00078 2.94172C8.17856 2.93616 8.33411 3.00005 8.46745 3.13338L12.8674 7.53338C12.9341 7.60005 12.9813 7.67227 13.0091 7.75005C13.0369 7.82783 13.0508 7.91116 13.0508 8.00005C13.0508 8.08894 13.0369 8.17227 13.0091 8.25005C12.9813 8.32783 12.9341 8.40005 12.8674 8.46672L8.46745 12.8667C8.34522 12.9889 8.19245 13.05 8.00911 13.05C7.82578 13.05 7.66745 12.9889 7.53411 12.8667C7.40078 12.7334 7.33411 12.575 7.33411 12.3917C7.33411 12.2084 7.40078 12.05 7.53411 11.9167L10.7841 8.66672L3.33411 8.66672C3.14522 8.66672 2.98689 8.60283 2.85911 8.47505C2.73133 8.34727 2.66745 8.18894 2.66745 8.00005C2.66745 7.81116 2.73133 7.65283 2.85911 7.52505C2.98689 7.39727 3.14522 7.33338 3.33411 7.33338L10.7841 7.33338Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ArrowAhead;
